var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canExportFeed
    ? _c("div", { staticClass: "p-0 ml-2" }, [
        _vm.exporting == 100 || _vm.exporting == 0
          ? _c("div", { staticClass: "d-flex align-items-center" }, [
              _c(
                "div",
                { staticClass: "mr-2" },
                [
                  _c("delete-button", {
                    attrs: {
                      label: _vm.label,
                      remove: _vm.startExporting,
                      disabled: !_vm.loaded || _vm.exporting > 0,
                    },
                  }),
                ],
                1
              ),
              _vm.help
                ? _c("i", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover",
                        value: _vm.help,
                        expression: "help",
                        modifiers: { hover: true },
                      },
                    ],
                    staticClass: "fas fa-question-circle text-light",
                    attrs: { title: "Remove record" },
                  })
                : _vm._e(),
            ])
          : _c("div", [
              _c("div", { staticClass: "mb-3 text-center" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.labelProgress) + " are in progress "
                ),
                _c("i", { staticClass: "far fa-spinner fa-spin fa-fw mr-2" }),
              ]),
              _c("div", { staticClass: "progress flex-fill" }, [
                _c(
                  "div",
                  {
                    staticClass: "progress-bar",
                    style: `width: ${_vm.exporting}%;`,
                    attrs: { role: "progressbar" },
                  },
                  [_vm._v(_vm._s(_vm.exporting.toFixed(2)) + "%")]
                ),
              ]),
            ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }